import React, { Component } from 'react';
import VideoSlider from './videoslider';

class BeaHero extends Component {

  render() {
    return (
      <section id="be-a-hero-section">
        <div className="container">
        <div className="row">
            <div className="col12">
            <h2>Be A Hero</h2>
            <p>Connecting with children each day lowers the chance for them to engage in risky behavior later in life.</p>
            <p>Whether you’re a parent, relative, teacher or friend, the time you spend with kids matters.</p>
            </div>
          </div>
          <div className="row">
            <div className="slider">
              <VideoSlider />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default BeaHero;


// WEBPACK FOOTER //
// ./src/components/beahero/beaherosection.js